<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-22 11:06:36
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-28 17:53:26
 * @Description: 
-->
<template>
  <section class="cta w-full h-276px py-60px flex-center flex-col lt-sm:h-345px lt-sm:py-60px">
    <h2
      class="cta-title pf-sc-semibold font-s-40px lh-56px text-center lt-sm:font-s-40px lt-sm:lh-56px"
    >
      开启您的智慧社区转型之旅
    </h2>
    <p class="cta-desc pf-sc-light font-s-18px text-#232325 lt-sm:font-s-18px lt-sm:mt-24px">
      提交您的需求，我们的专属顾问将在24小时内为您提供定制化解决方案
    </p>
    <button
      class="cta-btn pf-sc-regular h-52px mt-22px w-268px bg-primary text-white rounded-8px px-16px flex items-center justify-between hover:opacity-80 lt-sm:h-84px lt-sm:w-391px lt-sm:mt-24px lt-sm:rounded-8px"
      @click="openConsultation"
    >
      <span class="cta-btn-text font-s-16px lt-sm:font-s-26px">立即咨询</span>
      <i class="cta-btn-icon i-custom-arrow-right wh-18px lt-sm:wh-26px"></i>
    </button>
  </section>
</template>

<script setup lang="ts">
  const { openConsultation } = useConsultation()
</script>

<style scoped>
  .cta {
    background-size: cover;
    background-position: center;
    background-image: url('@/assets/images/bg-3.png');
  }

  @screen lt-sm {
    .cta {
      background-size: cover;
      background-position: center;
      background-image: url('@/assets/images/bg-3-mobile.png');
    }
  }
</style>
